module.exports = __webpack_public_path__ + "media/images/Core-Connector-c5a2fbe89456459a30be4407c6e84a02.svg";